import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogKeeper } from "../models/CatalogKeeper";

export const getCatalogKeepers = async (): Promise<CatalogKeeper[]> => {
	const apiService = new MESApiService();
	const resp = await apiService.callV2("[FAB].[GetKeepers]", []);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CatalogKeeper[];
	}
	throw new Error(resp.message || "Error fetching catalog keepers");
};

export const upsertCatalogKeeper = async (keeper: CatalogKeeper) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [
		{ name: "KeeperId", value: keeper.KeeperId },
		{ name: "KeeperCode", value: keeper.KeeperCode },
		{ name: "Description", value: keeper.Description },
		{ name: "Enabled", value: keeper.IsActive },
	];
	return await apiService.callV2("[FAB].[UpsertKeeper]", parameters);
};

export const deleteCatalogKeeper = async (keeperId: number) => {
	const apiService = new MESApiService();
	const parameters: spParameter[] = [{ name: "KeeperId", value: keeperId }];
	return await apiService.callV2("[FAB].[DeleteKeeper]", parameters);
};
